import { getField, updateField } from 'vuex-map-fields'
import { format } from 'date-fns/esm'
import axios from '@/lib/axios'

import account from './account'
import createPersistedState from "vuex-persistedstate";
import { createStore } from 'vuex';

const store = new createStore({
  modules: {
    account,
  },
  state: {
    announcement: ['', ''],
    storesWatched: [],
    globalNotificationMessage: '',
    globalNotificationType: 'danger',
    showGlobalNotification: false,
    loaderStack: 0,
  },
  plugins: [
    createPersistedState({
      paths: ['announcement'],
    }),
  ],
  mutations: {
    updateField,
    setAppVersion(state, ver) {
      state.appVersion = ver
    },
    watchStores(state, stores) {
      state.storesWatched = stores
      state.feedStarted = new Date()
    },
    stopStoreWatch(state, store) {
      let idx = state.storesWatched.indexOf(store)
      if (idx > -1) {
        state.storesWatched.splice(idx, 1)
      }
    },
    setGlobalNotificationMessage(state, err) {
      state.globalNotificationMessage = err
      state.showGlobalNotification = true
    },
    setGlobalNotificationType(state, type) {
      state.globalNotificationType = type
    },
    deactivateGlobalNotification(state) {
      state.globalNotificationMessage = ''
      state.showGlobalNotification = false
    },
    incLoader(state) {
      state.loaderStack += 1
    },
    decLoader(state) {
      state.loaderStack -= 1
      if (state.loaderStack < 0) state.loaderStack = 0
    },
    resetLoader(state) {
      state.loaderStack = 0
    },
    setAnnouncement(state, announcement) {
      state.announcement = announcement
    },
  },
  getters: { getField },
  actions: {
    setGlobalNotification({ commit }, { message, type }) {
      commit('setGlobalNotificationMessage', message)
      commit('setGlobalNotificationType', type)
      setTimeout(() => commit('deactivateGlobalNotification'), 5000)
    },
    async saveNewAnnouncement({ commit }, announcement) {
      let a = [format(new Date(), 'MM/dd/yyyy'), announcement]
      commit('setAnnouncement', a)
      await axios().post('/api/admin/announcement', a)
    },
    async loadAnnouncement({ commit }) {
      let resp = await axios({ loaderDelay: 8000 }).get(
        '/api/misc/announcement',
      )
      // Check to see if empty string and set announcement otherwise skip
      if(this.state.announcement[1] === "") {
        commit('setAnnouncement', resp.data)
      }
    },
  },
})

export default store
